import { Environments } from '@/config';
import { HELIX_WELLSPAN_PRODUCTION } from './helix-wellspan.production';
import { HELIX_WELLSPAN_STAGING } from './helix-wellspan.staging';

export const HELIX_WELLSPAN =
  import.meta.env.MODE === Environments.PROD ? HELIX_WELLSPAN_PRODUCTION : HELIX_WELLSPAN_STAGING;
